"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComments = exports.sortCommentsByDate = void 0;
const react_1 = require("react");
const sort_1 = require("@groupby/enrich-sdk/sort");
const predicate_language_1 = require("@groupby/predicate-language");
const ramda_1 = require("ramda");
const hooks_1 = require("../../../../../../hooks");
const localization_1 = require("../../../../../../localization");
const sortCommentsByDate = (a, b) => a.createdAt.valueOf() - b.createdAt.valueOf();
exports.sortCommentsByDate = sortCommentsByDate;
const useComments = ({ productId }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const token = (0, hooks_1.useToken)();
    const [comments, setComments] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [sortOrder, setSortOrder] = (0, react_1.useState)(sort_1.SortDirection.Ascending);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const lastCreatedId = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const loadComments = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            try {
                const loadedComments = yield client.comments.getMany({ filter: (0, predicate_language_1.where)((0, predicate_language_1.f) `subjectIds`, '@>', [(0, predicate_language_1.uuid)(productId)]) });
                const sortedComments = loadedComments.sort(exports.sortCommentsByDate);
                setComments(sortedComments);
            }
            catch (e) {
                addError(t({ key: 'COMMENT_LOADING_ERROR' }));
            }
            finally {
                setIsLoading(false);
            }
        });
        if (token) {
            void loadComments();
        }
    }, [addError, client, productId, t, token]);
    const createComment = (0, react_1.useCallback)((comment) => __awaiter(void 0, void 0, void 0, function* () {
        setIsSubmitting(true);
        try {
            const newComment = yield client.comments.createOne({ content: comment, subjectIds: [productId] });
            lastCreatedId.current = newComment.id;
            setComments((commentList) => (sortOrder === sort_1.SortDirection.Ascending ? [...commentList, newComment] : [newComment, ...commentList]));
            return newComment;
        }
        catch (e) {
            addError(t({ key: 'COMMENT_CREATE_ERROR' }));
            throw new Error(e.message);
        }
        finally {
            setIsSubmitting(false);
        }
    }), [addError, client, comments, productId, sortOrder, t]);
    const toggleCommentsSorting = (0, react_1.useCallback)(() => {
        setSortOrder((order) => (order === sort_1.SortDirection.Ascending ? sort_1.SortDirection.Descending : sort_1.SortDirection.Ascending));
        setComments((prevComments) => (0, ramda_1.reverse)(prevComments));
    }, []);
    return {
        comments,
        isLoading,
        sortOrder,
        isSubmitting,
        lastCreatedId: lastCreatedId.current,
        toggleCommentsSorting,
        createComment,
    };
};
exports.useComments = useComments;
